<template>
  <!-- <div class="row"> -->
  <div class="">
    <div class="dashboard_e_top homedashclassdO mb-3">
      <i class="noformobile">Hi {{ $store.state.user.userInfo.name }}!</i>
      <div class="d-flex dashboard_e_topinner flex-column align-items-center">
        <div class="header-title w-100 d-flex justify-content-center">
          <div class="dashboard_title">Welcome to MDrive</div>
        </div>
        <div class="searchbar_tops">
          <div class="iq-search-bar device-search">
            <form>
              <div class="input-prepend input-append">
                <label class="searchbox">
                  <input
                    class="search-query text search-input"
                    type="text"
                    placeholder="Search in MDrive (Coming Soon) "
                  />
                  <a class="search-link" href="javascript:void(0);">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.296 2.043c.407 1.817 1.284 2.716 3.317 3.089.14 0 .255.104.255.233s-.114.233-.255.233c-1.982.373-2.909 1.218-3.315 3.081a.246.246 0 0 1-.243.18.245.245 0 0 1-.245-.191c-.407-1.818-1.28-2.697-3.313-3.07-.14 0-.254-.104-.254-.233s.114-.233.254-.233c1.982-.373 2.91-1.223 3.317-3.087a.247.247 0 0 1 .241-.175c.117 0 .212.074.241.173Z"
                        fill="url(#_3085173834__a)"
                      ></path>
                      <path
                        d="M15.094 17.436A7.5 7.5 0 1 1 10 4.046v1.503A6 6 0 1 0 16.446 11h1.504a7.466 7.466 0 0 1-1.46 5.003l4.25 4.25a1 1 0 0 1-1.414 1.414l-4.232-4.231Z"
                        fill="url(#_3085173834__b)"
                      ></path>
                      <path
                        d="M13.666 8.964c-.857-.236-1.356-.615-1.527-1.4 0-.095-.084-.172-.187-.172s-.187.077-.187.171c-.257.786-.67 1.244-1.528 1.401-.103 0-.187.077-.187.171 0 .095.084.172.187.172.857.235 1.357.614 1.528 1.4 0 .095.084.171.187.171s.187-.076.187-.171c.257-.786.67-1.243 1.527-1.4.104 0 .187-.077.187-.172 0-.094-.083-.171-.187-.171Z"
                        fill="url(#_3085173834__c)"
                      ></path>
                      <defs>
                        <linearGradient
                          id="_3085173834__a"
                          x1="-6.063"
                          y1="11.915"
                          x2="13.914"
                          y2="29.878"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#03A5AB"></stop>
                          <stop offset="1" stop-color="#8B3DFF"></stop>
                        </linearGradient>
                        <linearGradient
                          id="_3085173834__b"
                          x1="-6.063"
                          y1="11.915"
                          x2="13.914"
                          y2="29.878"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#03A5AB"></stop>
                          <stop offset="1" stop-color="#8B3DFF"></stop>
                        </linearGradient>
                        <linearGradient
                          id="_3085173834__c"
                          x1="-6.063"
                          y1="11.915"
                          x2="13.914"
                          y2="29.878"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#03A5AB"></stop>
                          <stop offset="1" stop-color="#8B3DFF"></stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </a>
                </label>
              </div>
            </form>
          </div>
        </div>
        <div class="userboxpart" >
          <div class="icon"
            ><img
              class="rounded img-fluid avatar-40"
              :src="img_url + '' + $store.state.user.userInfo.user_image"
              :alt="$store.state.user.userInfo.name"
          /></div>
          <h4>
            <i>{{ $store.state.user.userInfo.name }}</i>
            <p>{{ $store.state.user.userInfo.role_name }}</p>
          </h4>
        </div>
      </div>
    </div>
    <div class="htheightDash">
      <div class="">
        <div class="card m-0 p-0">
          <div
            class="card-header d-flex justify-content-between p-0 mb-2"
            v-if="$store.state.home.tableFolderLoader != 2"
          >
            <div class="header-title">
              <h4 class="card-title">Folders <span class="currentPaginationCls">(Currently viewing {{$store.state.home.folderList.length}} of {{$store.state.home.totalFolders}} items)</span></h4>
            </div>
          </div>
          <ListingFolder :isMain="mainParam" />
        </div>
      </div>
      <div class="">
        <div class="card m-0 p-0">
          <div
            class="card-header d-flex justify-content-between p-0 mb-3  mt-4"
            v-if="$store.state.home.tableFileLoader != 2"
          >
            <div class="header-title">
              <h4 class="card-title">Files <span class="currentPaginationCls">(Currently viewing {{$store.state.home.fileList.length}} of {{$store.state.home.fileCount}} items)</span></h4>
            </div>
          </div>
          <ListingFiles :isMain="mainParam" />
        </div>
      </div>
      <div class="" v-if="$store.state.home.tableFolderLoader === 2 && $store.state.home.tableFileLoader === 2">
        <ComponentNoData />
      </div>
    </div>
  
  </div>
  <DragDrop />
</template>
<!-- <script setup>
    import bgImage from '@/assets/images/background.png';
</script> -->
<script>
import ListingFolder from "@/components/Folder/ListingFolder.vue";
import ListingFiles from "@/components/Folder/ListingFiles.vue";
import DragDrop from "@/components/Folder/DragDrop.vue";
import ComponentNoData from "@/components/Widgets/Icon/ComponentNoData.vue";
import $ from "jquery";
export default {
  name: "HomePage",
  components: {
    ListingFolder,
    ListingFiles,
    DragDrop,
    ComponentNoData,
  },
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
      mainParam: "home",
      showDropArea: false,
      dragCounter: 0,
      homeTotalFolder: 1,
      files: [],
      allowedTypes: ["image/jpeg", "image/png", "application/pdf", "application/zip"],
    };
  },
  async mounted() {
    this.$store.state.pageTitle = "";
    this.$store.state.isLogin = 1;
    this.$store.state.currentPageSlug = "home";
    this.$store.state.user.PageNotFound = null;
    $("body").removeClass("sidebar-main");
    if (this.$store.state.isActiveToken != "1") {
      // console.log(this.currentDate);
    } else {
      // await this.loadDashboardCnt();
    }
  },
};
</script>
